export default "__VITE_PUBLIC_ASSET__8145a635__"